import React from 'react';
import icon from '../assets/icon.png';
import { Buttons } from '../components/Buttons';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import PublicListingSection from '../components/PublicListingSection';

const portfolioTypes = [
  'Corporate office buildings',
  'Shopping Centers',
  'Medical and Professional office', 
  'Single Homes and Apartments',
];

const locations = [
  { city: 'San Francisco', area: 'Financial District' },
  { city: 'Downtown Oakland', area: 'Oakland CBD' },
  { city: 'Silicon Valley', area: 'San Jose' },
  { city: 'South San Francisco', area: 'SoSF' },
  { city: 'Berkeley', area: 'East Bay' },
  { city: 'Tri-Valley', area: 'San Ramon, Dublin, Pleasanton' },
];

const differentiators = [
  {
    title: 'Prime Locations',
    detail: 'Position your business in high-demand commercial zones throughout the Bay Area.',
  },
  {
    title: 'Flexible Leasing Options',
    detail: 'Short-term and long-term lease solutions available to fit your business needs.',
  },
  {
    title: 'Modern Infrastructure',
    detail: 'Spaces equipped with high-speed connectivity and essential amenities.',
  },
  {
    title: 'Professional Management',
    detail: 'Ongoing maintenance and property support included with every lease.',
  },
];

const leasingProcess = [
  { num: '01', title: 'Consultation', detail: 'We understand your business needs, team size, and budget.' },
  { num: '02', title: 'Property Matching', detail: 'We present office spaces aligned with your specific requirements.' },
  { num: '03', title: 'Tours & Evaluation', detail: 'Visit shortlisted properties and evaluate suitability.' },
  { num: '04', title: 'Lease Negotiation', detail: 'We assist in securing the most favorable lease terms for you.' },
  { num: '05', title: 'Move-In Support', detail: 'Smooth onboarding into your new workspace from day one.' },
];

const whyChoose = [
  'Local market expertise',
  'Access to exclusive listings',
  'Transparent leasing guidance',
  'Professional negotiation support',
  'End-to-end assistance',
];

const Office = () => {
  return (
    <div className="w-full bg-black">

      {/* Hero */}
      <div className="w-full bg-[#1A1A1A] px-[4rem] py-[5rem] flex flex-col items-center gap-[1rem] text-center border-b border-[#262626]">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Find the Right Office Space for Your Business</p>
        </div>
        <h1 className="text-[55px] leading-tight font-bold text-gradient">
          Office Space Listings in San Francisco & The Bay Area
        </h1>
        <p className="text-white text-[18px] font-light max-w-[900px]">
          Millennium Realty provides premium office space listings throughout San Francisco and the Bay Area, designed to meet the needs of startups, growing businesses, and established enterprises. From modern corporate offices to flexible workspaces, we help you secure a location that enhances productivity, brand image, and long-term success.
        </p>
        {/* <a
          href={featuredProperty.link}
          target="_blank"
          rel="noreferrer"
          className="featured-property-card group mt-[1.5rem] w-full max-w-[820px] overflow-hidden rounded-[18px] border border-[#3A3320] bg-[#111] text-left shadow-[0_30px_80px_rgba(0,0,0,0.35)]"
        >
          <div className="relative flex flex-col sm:flex-row">
            <div className="relative h-[220px] sm:h-auto sm:w-[42%] overflow-hidden bg-[#222]">
              <img
                src={featuredProperty.image}
                alt={featuredProperty.title}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent sm:bg-gradient-to-r sm:from-transparent sm:via-black/10 sm:to-black/70" />
              <span className="absolute left-[1rem] top-[1rem] rounded-full border border-white/20 bg-black/60 px-[0.9rem] py-[0.35rem] text-[13px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md">
                Featured
              </span>
            </div>
            <div className="relative flex flex-1 flex-col gap-[1rem] p-[1.4rem] sm:p-[1.8rem]">
              <div className="absolute right-[1.25rem] top-[1.25rem] h-[42px] w-[42px] rounded-full border border-[#EEC24B]/45 bg-[#EEC24B]/10 text-[#EEC24B] transition-all duration-300 group-hover:bg-[#EEC24B] group-hover:text-black">
                <FaExternalLinkAlt className="mx-auto mt-[12px]" size={16} />
              </div>
              <div className="flex items-center gap-[0.55rem] pr-[3.4rem] text-[#EEC24B]">
                <FaMapMarkerAlt size={15} className="flex-shrink-0" />
                <span className="text-[14px] font-semibold uppercase tracking-[0.16em]">Opportunity</span>
              </div>
              <h2 className="max-w-[520px] text-[28px] font-bold leading-tight text-white sm:text-[34px]">
                {featuredProperty.title}
              </h2>
              <p className="max-w-[560px] text-[16px] font-light leading-relaxed text-[#BDBDBD]">
                View the latest listing details, availability, and property information.
              </p>
              <div className="flex items-center gap-[0.8rem] pt-[0.35rem]">
                <span className="h-[1px] w-[52px] bg-[#EEC24B]" />
                <span className="text-[15px] font-semibold text-white transition-colors duration-300 group-hover:text-[#EEC24B]">
                  Open property listing
                </span>
              </div>
            </div>
          </div>
        </a> */}
      </div>

      <PublicListingSection
        listingType="property"
        eyebrow="Live Property Inventory"
        title="Published Property Listings"
        description="Browse current property listing entries added by the admin team."
      />

      {/* Portfolio & Locations */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-wrap gap-[4rem] justify-between">

          <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Property Types</p>
            </div>
            <h2 className="text-[42px] font-bold text-gradient">Our Office Property Portfolio Includes</h2>
            <ul className="flex flex-col gap-[0.8rem]">
              {portfolioTypes.map((item, i) => (
                <li key={i} className="flex items-center gap-[0.8rem]">
                  <FaCheckCircle className="text-[#EEC24B] flex-shrink-0" size={18} />
                  <p className="text-white text-[18px] font-light">{item}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Coverage Areas</p>
            </div>
            <h2 className="text-[42px] font-bold text-gradient">Strategic Locations Across the Bay Area</h2>
            <p className="text-white text-[17px] font-light mb-[0.5rem]">
              We offer office listings in key business hubs, including:
            </p>
            <div className="flex flex-wrap gap-[1rem]">
              {locations.map((loc, i) => (
                <div key={i} className="bg-[#1A1A1A] border border-[#262626] rounded-lg px-[1.5rem] py-[1rem] hover:border-[#EEC24B] transition-all duration-300">
                  <p className="text-[#EEC24B] text-[14px] font-semibold uppercase tracking-wider">{loc.area}</p>
                  <p className="text-white text-[17px] font-semibold">{loc.city}</p>
                </div>
              ))}
            </div>
            <p className="text-[#999] text-[16px] font-light mt-[0.5rem]">
              Each location is selected for accessibility, visibility, and business growth potential.
            </p>
          </div>

        </div>
      </div>

      {/* What Sets Apart */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Our Advantage</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">What Sets Our Office Listings Apart</h2>
          </div>
          <div className="flex flex-wrap gap-[2rem] justify-center">
            {differentiators.map((item, i) => (
              <div key={i} className="flex-1 min-w-[240px] max-w-[340px] bg-[#111] border border-[#262626] rounded-lg p-[2rem] flex flex-col gap-[1rem] hover:border-[#EEC24B] transition-all duration-300">
                <div
                  className="w-[50px] h-[50px] gradient rounded-lg flex items-center justify-center text-black font-bold text-[22px]"
                >
                  {i + 1}
                </div>
                <h3 className="text-white text-[20px] font-bold">{item.title}</h3>
                <p className="text-[#999] text-[16px] font-light">{item.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Leasing Process */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">How It Works</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Our Leasing Process</h2>
          </div>

          <div className="relative flex flex-col gap-[0]">
            {leasingProcess.map((step, i) => (
              <div key={i} className={`flex items-start gap-[2rem] py-[2rem] px-[2rem] ${i % 2 === 0 ? 'bg-[#1A1A1A]' : 'bg-[#111]'} border border-[#262626] ${i === 0 ? 'rounded-t-lg' : ''} ${i === leasingProcess.length - 1 ? 'rounded-b-lg' : ''} hover:border-[#EEC24B] transition-all duration-300`}>
                <span className="text-gradient text-[48px] font-bold flex-shrink-0 w-[70px]">{step.num}</span>
                <div className="flex flex-col gap-[0.5rem]">
                  <h3 className="text-white text-[22px] font-bold">{step.title}</h3>
                  <p className="text-[#999] text-[17px] font-light">{step.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col items-center gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Our Commitment</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Why Choose Millennium Realty for Office Leasing?</h2>
          </div>
          <div className="flex flex-wrap gap-[1.5rem] justify-center w-full">
            {whyChoose.map((item, i) => (
              <div key={i} className="flex items-center gap-[0.8rem] bg-[#111] border border-[#262626] rounded-lg px-[2rem] py-[1.2rem] hover:border-[#EEC24B] transition-all duration-300">
                <FaCheckCircle className="text-[#EEC24B] flex-shrink-0" size={20} />
                <p className="text-white text-[17px] font-semibold">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full px-[4rem] py-[5rem] bg-black text-center flex flex-col gap-[1.5rem] items-center">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Ready to Find Your Perfect Office?</p>
        </div>
        <h2 className="text-[45px] font-bold text-gradient">Secure Your Office Space Today</h2>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Whether you're expanding, relocating, or launching a new venture, Millennium Realty helps you find the perfect office space in the Bay Area. Contact us today to explore available office listings.
        </p>
        <div className="flex gap-[1rem] flex-wrap justify-center">
          <Buttons title="Explore Office Listings" width="230px" href="#listings" />
          <Link to="/contact">
            <button className="py-[0.8rem] px-[2rem] text-white font-semibold rounded-lg border border-[#EEC24B] hover:bg-[#EEC24B] hover:text-black transition-all duration-300">
              Contact Us Today
            </button>
          </Link>
        </div>
      </div>

    </div>
  );
};

export default Office;
